import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import { ITepCompany } from 'types/tep';
import { ISelectOption } from 'types/select';
import Loader from 'core/react/general/Loader';
import TagPicker from 'core/react/general/form/TagPicker';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';

interface ICompaniesPickerProps {
  disabled: boolean;
  value: number[];
  onChange: (value: number[]) => void;
}

export const CompaniesPicker: FC<ICompaniesPickerProps> = (props) => {
  const { disabled, value, onChange } = props;

  const { companies, parameters } = useSelector(tepHistoryReportSelector);

  const { f, fc } = useI18n();
  let content = null;

  const formatEventTypes = ({ id, name }: ITepCompany) => ({
    value: id,
    label: fc({ prefix: 'device-event', id: name }),
  });

  if (companies) {
    const items = companies.map(formatEventTypes);

    const compare = () => (a: ISelectOption<number>, b: ISelectOption<number>) => {
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      return 0;
    };
    content = (
      <TagPicker
        data={items}
        value={value || parameters?.companies || []}
        onChange={onChange}
        placeholder={f('search')}
        label={f('Select Company')}
        sort={compare}
        disabled={disabled}
        style={{ minHeight: '37px' }}
      />
    );
  } else content = <Loader />;

  return <div className="event-type-picker">{content}</div>;
};
